export default function NGContainer({ children }) {
  return <div className="ng-container">{children}</div>;
}
